@if (shouldShowPlayer) {
  <div class="audio-player" [class.compact]="isCompact" [class.full-page]="!isCompact"
       [class.position-top]="isCompact && playerPosition === 'top'"
       [class.position-bottom]="isCompact && playerPosition === 'bottom'">
    <app-playback-eligibility>
      @if (isCompact) {
        <div class="compact-header">
          <div class="track-info">
            @if (currentTrackImageUrl) {
              <img [src]="currentTrackImageUrl" alt="" class="track-thumbnail" />
            }
            <div class="track-details">
              <strong>{{ currentTrack?.title }}</strong>
              <span>{{ currentTrack?.artist }}</span>
            </div>
          </div>
          <button type="button" class="open-player" aria-label="Open full player" (click)="openFullPlayer()">
            <ion-icon name="expand-outline"></ion-icon>
          </button>
        </div>
      } @else if (currentTrack) {
        <div class="track-info">
          @if (currentTrackImageUrl) {
            <img [src]="currentTrackImageUrl" alt="{{currentTrack.title}} thumbnail" class="track-thumbnail" />
          }
          <div class="track-details">
            <h3>{{ currentTrack.title }}</h3>
            <p>{{ currentTrack.artist }}</p>
          </div>
        </div>
      }

      <plyr #plyr [plyrOptions]="plyrOptions" (plyrInit)="plyrInit($event)"></plyr>

      @if (!isCompact) {
        <div class="playlist">
          <h4>{{ 'general.playlist' | translate }}</h4>
          <ion-content>
            <ul>
              @for (track of playlist; track track; let i = $index) {
                <li [class.active]="track === currentTrack" (click)="selectTrack(i)">
                  <span>{{ track.title }}</span>
                  <span>{{ track.artist }}</span>
                </li>
              }
            </ul>
          </ion-content>
        </div>
      }
    </app-playback-eligibility>
  </div>
}
